<script lang="ts" setup>
import { useUserBehaviorEvents } from '~/composables/tracking-events/use-user-behavior-events'

const { trackingButtonClick } = useUserBehaviorEvents()

const props = defineProps({
  buttonId: {
    type: String || Number,
    default: '',
  },
  buttonName: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'button',
  },
  customClass: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: 'default',
    validator: (value: string) => ['small', 'default', 'large'].includes(value),
  },
  variant: {
    type: String,
    default: 'outline',
    validator: (value: string) =>
      ['primary', 'outline', 'link', 'text'].includes(value),
  },
  loading: {
    type: Boolean,
    default: false,
  },
  prefixIcon: {
    type: String,
    default: '',
  },
  prefixIconImage: {
    type: String,
    default: '',
  },
  suffixIcon: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
})

const route = useRoute()
const { isMobile } = useDevice()
const emit = defineEmits(['click'])

const handleClickButton = (): void => {
  trackingButtonClick({
    buttonId: props.buttonId ?? '',
    buttonName: props.buttonName ?? '',
    pageUrl: route.fullPath
  })
  emit('click')
}
</script>
<template>
  <VBtn
    :id="buttonId"
    :name="buttonName"
    :disabled="props.disabled"
    :class="{
      'base-button': true,
      [props.customClass]: true,
      [`v-btn--${props.variant}`]: Boolean(props.variant),
      'base-button--mobile': isMobile,
    }"
    variant="text"
    :type="props.type"
    :size="props.size"
    :loading="props.loading"
    :aria-label="props.label || 'icon button'"
    @click="handleClickButton"
  >
    <div v-if="props.icon" :class="props.icon" />
    {{ props.label }}
    <template v-if="props.prefixIcon || props.prefixIconImage" #prepend>
      <i
        v-if="props.prefixIcon"
        :class="{
          'v-btn__icon': true,
          [props.prefixIcon]: true,
        }"
      />
      <img
        v-if="props.prefixIconImage"
        class="v-btn__icon-image"
        :src="props.prefixIconImage"
        alt="prefix"
      />
    </template>
    <template v-if="props.suffixIcon" #append>
      <i
        :class="{
          'v-btn__icon': true,
          [props.suffixIcon]: true,
        }"
      />
    </template>
  </VBtn>
</template>
